export const BOOK_DEMO_URL = 'https://calendly.com/d/cq6z-5t7-5kr';
export const SWEATPALS_UNIVERSITY_URL = 'https://university.sweatpals.com/';
